<template>
    <div class="sss_zhuanlan">
        <div class="header">
            <div class="user-section">
                <div class="user">
                    <div class="avatar-section">
                        <img class="avatar" v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" alt="头像" />
                        <img class="avatar" v-else src="@/assets/default_avatar.png" alt="头像" />
                        <div class="name">{{ userInfo.nickname }}（{{ roleTabs[activeRole].label }}）</div>
                    </div>
                    <div>
                        <div class="role-tabs">
                            <span v-for="(tab, index) in roleTabs" :key="index"
                                :class="{ active: activeRole === index }" @click="switchRole(index)">
                                {{ tab.label }}
                            </span>
                        </div>
                        <div class="content">
                            <div>
                                <div>双色球：{{ userInfo.doubleColorBall || 0 }}</div>
                                <div>大乐透：{{ userInfo.lottery || 0 }}</div>
                            </div>
                            <div>
                                <div>福彩3D：{{ userInfo.fucai3d || 0 }}</div>
                                <div>体彩排三：{{ userInfo.pailieSan || 0 }}</div>
                            </div>
                            <div>
                                <div>缩币缩水单：{{ userInfo.payCount || 0 }}</div>
                                <div>免费缩水单：{{ userInfo.freeCount || 0 }}</div>
                            </div>
                            <div>
                                <div>浏览人数：{{ userInfo.viewCount || 0 }}</div>
                                <div>粉丝人数：{{ userInfo.fansCount || 0 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="msg">
                    座右铭或者简介：
                    <div> {{ userInfo.motto }}</div>
                </div>
            </div>

            <div class="sidebar-section">
                <div class="sidebar-grid">
                    <div class="grid-item" @click="tiaozhuan('申请缩水师')">
                        <div class="icon-wrapper">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                <circle cx="12" cy="7" r="4" />
                            </svg>
                        </div>
                        <span>申请缩水师</span>
                    </div>
                    <div class="grid-item" @click="tiaozhuan('申请EXCEL表修复')">
                        <div class="icon-wrapper">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="16" y1="13" x2="8" y2="13" />
                                <line x1="16" y1="17" x2="8" y2="17" />
                                <polyline points="10 9 9 9 8 9" />
                            </svg>
                        </div>
                        <span>申请EXCEL表修复</span>
                    </div>
                    <div class="grid-item" @click="tiaozhuan('申请技巧师')">
                        <div class="icon-wrapper">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 20h9" />
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                            </svg>
                        </div>
                        <span>申请EXCEL技巧师</span>
                    </div>
                    <div class="grid-item" @click="tiaozhuan('定制EXCEL表申请')">
                        <div class="icon-wrapper">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="3" width="7" height="7" />
                                <rect x="14" y="3" width="7" height="7" />
                                <rect x="14" y="14" width="7" height="7" />
                                <rect x="3" y="14" width="7" height="7" />
                            </svg>
                        </div>
                        <span>申请定制EXCEL表</span>
                    </div>
                    <div class="grid-item" @click="tiaozhuan('申请投注站帮扶')">
                        <div class="icon-wrapper">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 20v-6" />
                                <path d="M18 20v-6" />
                                <path d="M6 20v-6" />
                                <path
                                    d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                            </svg>
                        </div>
                        <span>申请投注站帮扶</span>
                    </div>
                    <div class="grid-item" @click="tiaozhuan('申请定制缩水软件')">
                        <div class="icon-wrapper">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path
                                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                                <line x1="12" y1="22.08" x2="12" y2="12" />
                            </svg>
                        </div>
                        <span>申请定制缩水软件</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="tables-container">
            <div class="table1">
                <div class="tit">
                    <div>
                        <span>最新预测</span>
                        <span v-for="(item, index) in tabArr" :key="index" :class="{ active: index === tabActive }"
                            @click="tabActive = index">
                            {{ item.title }}
                        </span>
                    </div>
                    <span>更多预测</span>
                </div>
                <div class="grid" v-loading="latest_forecast_loading">
                    <div>
                        <span>序号</span>
                        <span>最新缩水预测</span>
                        <span>类型</span>
                        <span>发布时间</span>
                        <span>操作</span>
                    </div>
                    <div v-for="(item, index) in latest_forecast_list" :key="index">
                        <span>{{ index + 1 }}</span>
                        <span style="white-space: nowrap;">{{ handleShrinkageForecast(item) }}</span>
                        <span>{{ item.coin ? '付费' : '免费' }}</span>
                        <span>{{ item.createTime.substr(0, 10) }}</span>
                        <el-button
                            @click="handleDownload(item, item.preIndexType, item.preIndexTypeName, item.preIndexTypeAlies)"
                            type="text" size="small">下载</el-button>
                    </div>
                </div>
            </div>
            <div class="table2">
                <div class="tit">
                    <div>
                        <span>近期成绩</span>
                        <span v-for="(item, index) in lotteryArr" :key="index"
                            :class="{ active: index === lotteryActive }" @click="lotteryActive = index">
                            {{ item.title }}
                        </span>
                    </div>
                    <span>更多预测</span>
                </div>
                <div class="grid" v-loading="recent_results_loading">
                    <div
                        :style="['pl3', 'fc3d'].includes(lotteryArr[lotteryActive].type) ? 'grid-template-columns: 1fr 2fr repeat(6, 1fr);' : ''">
                        <span>序号</span>
                        <span>期号/开奖号</span>
                        <span v-for="(item, index) in ys[lotteryArr[lotteryActive].type]" :key="index">{{ item.label
                        }}</span>
                    </div>
                    <div v-for="(item, index) in recent_results_list" :key="index"
                        :style="['pl3', 'fc3d'].includes(lotteryArr[lotteryActive].type) ? 'grid-template-columns: 1fr 2fr repeat(6, 1fr);' : ''">
                        <span>{{ index + 1 }}</span>
                        <span style="flex-direction: column">
                            {{ item.number }}期
                            <b v-html="handleopenNbr(item.openNbr)"></b>
                        </span>
                        <span v-for="(ite, idx) in ys[lotteryArr[lotteryActive].type]" :key="idx" class="sheetItem">
                            <b v-html="jsAttr(item.preChampionVOList, ite.value)"></b>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { getInfo } from "@/api/hangjiaguanli";
import tableMixin from '@/views/homePage/menu/suoshuidan_dating/table/mixin.js'

export default {
    watch: {
        lotteryActive(val) {
            this.recent_achievements()
        }
    },
    mixins: [tableMixin],
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API + '/stage-api',
            userInfo: {},

            // 角色切换
            activeRole: 0,
            roleTabs: [
                { label: '缩水师', value: 'sss' },
                { label: '技巧师', value: 'jqs' },
                { label: '软件师', value: 'rjs' },
            ],

            sidebarItems: [
                {
                    title: "缩水单大厅",
                    arr: [
                        { name: "申请缩水师" },
                        { name: '缩水单大厅双色球半免费区' },
                        { name: '缩水单大厅大乐透半免费区' },
                        { name: '缩水单大厅3D半免费区' },
                        { name: '缩水单大厅排列三半免费区' },
                    ]
                },

                {
                    title: "EXCEL专区",
                    arr: [
                        { name: '申请技巧师' },
                        { name: 'EXCEL专区双色球VIP区' },
                        { name: 'EXCEL专区大乐透VIP区' },
                        { name: 'EXCEL专区3D-VIP区' },
                        { name: 'EXCEL专区排列三VIP区' },
                        { name: '闲置EXCEL改表,修复申请' },
                        { name: '定制EXCEL表申请' },
                    ]
                },

                {
                    title: "缩水软件特区",
                    arr: [
                        // {name: '申请软件交易师'},
                        // {name: '免费软件区'},
                        // {name: '缩水软件VIP区'},
                        // {name: '缩水软件（个人/众筹）定制'},
                    ]
                },

                {
                    title: "实体投注站帮扶中心",
                    arr: [
                        // {name: '彩票投注站申请帮扶'},
                        // {name: '彩票代表申请'},
                        // {name: '实战超市（仅限彩票投注站认购）'},
                        // {name: '众筹招股大厅'},
                    ]
                },
            ],

            // 预测列表
            latest_forecast_list: [],
            latest_forecast_loading: false,

            tabArr: [
                { title: '预测列表' },
                { title: '近期成绩' },
                { title: '历史排序' },
            ],
            tabActive: 0,

            lotteryArr: [
                { title: '双色球', type: 'ssq', preType: 0 },
                { title: '大乐透', type: 'dlt', preType: 1 },
                { title: '福彩3D', type: 'fc3d', preType: 2 },
                { title: '排列三', type: 'pl3', preType: 3 },
            ],
            lotteryActive: 0,

            recent_results_list: [],
            recent_results_loading: false,

            ys: {
                ssq: [
                    { label: '90-99.9万', value: 0 },
                    { label: '80-89.9万', value: 0 },
                    { label: '50-59.9万', value: 1 },
                    { label: '15-21.9万', value: 2 },
                    { label: '4-4.9万', value: 3 },
                    { label: '5005注以下', value: 4 },
                    { label: '杀6蓝', value: 5 },
                    { label: '围4蓝', value: 6 },
                ],
                dlt: [
                    { label: '27-29.9万', value: 7 },
                    { label: '20-26.9万', value: 0 },
                    { label: '15-17.9万', value: 1 },
                    { label: '3-5.9万', value: 2 },
                    { label: '1-1.9万', value: 3 },
                    { label: '4368注以下', value: 4 },
                    { label: '杀5后', value: 5 },
                    { label: '围3后', value: 6 },
                ],
                fc3d: [
                    { label: '800-899注', value: 5 },
                    { label: '700-799注', value: 0 },
                    { label: '400-599注', value: 1 },
                    { label: '200-399注', value: 2 },
                    { label: '50-199注', value: 3 },
                    { label: '1-49注', value: 4 },
                ],
                pl3: [
                    { label: '800-899注', value: 5 },
                    { label: '700-799注', value: 0 },
                    { label: '400-599注', value: 1 },
                    { label: '200-399注', value: 2 },
                    { label: '50-199注', value: 3 },
                    { label: '1-49注', value: 4 },
                ],
            }

        }
    },
    mounted() {
        this.getList()

    },
    methods: {
        // 处理最新缩水预测内容
        handleShrinkageForecast(item) {
            const maping = ['双色球', '大乐透', '福彩3D', '排列三']
            return `${maping[item.preType]}第（${item.number}）期${item.preIndexTypeName}指标`
        },
        // 处理近期成绩开奖号样式
        handleopenNbr(openNbr) {
            if (openNbr) {
                const splitArr = openNbr.split(' ')
                const start = splitArr.slice(0, splitArr.length - 1);
                const end = splitArr[splitArr.length - 1];

                return `
                    <span style="color:#f00"> ${start.join(' ')} </span>
                    +
                    <span style="color:#2899DF">${end}</span>
                `;
            }
        },

        jsAttr(arr, val) {

            if (arr.length) {
                const targetDb = arr.find(item => item.preIndexType === String(val))
                if (targetDb) {
                    const { isWin, isUpdate } = targetDb

                    if (isUpdate === '0') {
                        return `--`
                    } else if (isWin === '1') {
                        return `<span style="color:#52c41a;font-weight:bold;font-size:16px;">✓</span>`
                    } else {
                        return `<span style="color:#ff4d4f;font-weight:bold;font-size:16px;">✗</span>`
                    }

                } else {
                    return '--'
                }
            } else {
                return `--`
            }
        },


        tiaozhuan(temp) {


            const mapping = {
                // 缩水单大厅
                '申请缩水师': '/personalCenter/hangjiaguanli/apply_sss',
                '缩水单大厅双色球半免费区': '/ssddt?caizhong=sss',
                '缩水单大厅大乐透半免费区': '/ssddt?caizhong=dlt',
                '缩水单大厅3D半免费区': '/ssddt?caizhong=3d',
                '缩水单大厅排列三半免费区': '/ssddt?caizhong=pl3',

                // EXCEL专区
                '申请技巧师': '/personalCenter/hangjiaguanli/apply_jqs',

                'EXCEL专区双色球VIP区': '/excel?caizhong=sss',
                'EXCEL专区大乐透VIP区': '/excel?caizhong=dlt',
                'EXCEL专区3D-VIP区': '/excel?caizhong=3d',
                'EXCEL专区排列三VIP区': '/excel?caizhong=pl3',
                '闲置EXCEL改表,修复申请': '/excel?caizhong=xianzhi',
                '定制EXCEL表申请': '/excel?caizhong=xianzhi',

                // 缩水软件特区
                // '申请软件交易师':'/personalCenter/hangjiaguanli/apply_software',
                // '免费软件区':'/software',
                // '缩水软件VIP区':'/software?vip=1',
                // '缩水软件（个人/众筹）定制':'/personalCenter/hangjiaguanli/software_custom',

                // 实体投注站帮扶中心
                // '彩票投注站申请帮扶':'/personalCenter/hangjiaguanli/apply_betting_site',
                // '彩票代表申请':'/personalCenter/hangjiaguanli/apply_lottery_representative',
                // '实战超市（仅限彩票投注站认购）':'/personalCenter/hangjiaguanli/apply_real_estate',
                // '众筹招股大厅':'/personalCenter/hangjiaguanli/apply_crowd_funding',

            }

            this.$router.push(mapping[temp])

        },
        getList() {
            getInfo({
                userId: this.vuex_userInfo.userId,
            }).then(res => {
                this.userInfo = res.data;
                this.latest_forecast()
                this.recent_achievements()
            })
        },
        // 预测列表
        latest_forecast() {
            this.latest_forecast_loading = true
            this.$http.get('/stage-api/pre/detail/list', {
                params: {
                    createUser: this.vuex_userInfo.userId,
                    pageNum: 1,
                    pageSize: 1000,
                }
            }).then(res => {
                this.latest_forecast_list = res.rows.splice(0, 10)
            }).finally(() => {
                this.latest_forecast_loading = false
            })
        },

        // 近期成绩
        recent_achievements() {
            this.recent_results_list = []
            this.recent_results_loading = true
            this.$http.get('/stage-api/pre/detail/achievmentList', {
                params: {
                    preType: this.lotteryArr[this.lotteryActive].preType,
                    createUser: this.vuex_userInfo.userId,
                }
            }).then(res => {
                this.recent_results_loading = false
                let db = res.rows.splice(0, 20)
                this.recent_results_list = db
            }).catch(err => {
                console.log('err', err);
                this.recent_results_loading = false
            })
        },

        // 切换角色
        switchRole(index) {
            this.activeRole = index
        }
    }
}
</script>

<style lang="scss" scoped>
.sss_zhuanlan {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    background: #f5f7fa;
    min-height: 100vh;

    .header {
        display: flex;
        gap: 20px;

        .user-section {
            flex: 1;
            background: #fff;
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

            .user {
                display: flex;
                align-items: flex-start;

                .avatar-section {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 15px;
                    flex: unset;
                    width: 100px;

                    .avatar {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        border: 2px solid #2899DF;
                        object-fit: cover;
                    }

                    .name {
                        color: #333;
                        font-weight: bold;
                        font-size: 12px;
                        margin-top: 5px;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 80px;
                    }
                }

                >div {
                    flex: 1;

                    .role-tabs {
                        display: flex;
                        gap: 10px;
                        margin-bottom: 15px;

                        span {
                            padding: 4px 16px;
                            border-radius: 5px;
                            font-size: 14px;
                            cursor: pointer;
                            background: #f5f7fa;
                            color: #666;
                            transition: all 0.3s;

                            &:hover {
                                background: #e8f4fc;
                            }

                            &.active {
                                background: #2899DF;
                                color: #fff;
                            }
                        }
                    }

                    .content {
                        display: flex;
                        justify-content: space-between;

                        >div {
                            display: flex;
                            flex-direction: column;
                            gap: 8px;

                            >div {
                                font-size: 14px;
                                color: #666;
                                display: flex;
                                align-items: center;
                                gap: 8px;

                                &::before {
                                    content: '';
                                    width: 4px;
                                    height: 4px;
                                    background: #2899DF;
                                    border-radius: 50%;
                                }
                            }
                        }
                    }
                }
            }

            .msg {
                color: #666;
                margin-top: 20px;
                padding-top: 15px;
                border-top: 1px dashed #e8e8e8;
                display: flex;
                flex-direction: column;
                gap: 10px;

                >div {
                    flex: 1;
                    color: #999;
                    font-size: 14px;
                }
            }
        }

        .sidebar-section {
            width: 280px;

            .sidebar-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 12px;

                .grid-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 16px 12px;
                    background: #fff;
                    border-radius: 12px;
                    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
                    }

                    .icon-wrapper {
                        width: 48px;
                        height: 48px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: linear-gradient(135deg, #e8f4fc 0%, #d4eaf7 100%);
                        border-radius: 50%;
                        color: #2899DF;
                        margin-bottom: 8px;

                        svg {
                            width: 24px;
                            height: 24px;
                        }
                    }

                    span {
                        font-size: 13px;
                        color: #333;
                        font-weight: 500;
                        text-align: center;
                    }
                }
            }
        }
    }

    .tables-container {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .table1 {
            width: 100%;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            min-height: 300px;

            .tit {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: linear-gradient(135deg, #2899DF 0%, #1a7fc4 100%);
                padding: 12px 20px;

                >div {
                    display: flex;
                    align-items: center;
                    gap: 15px;

                    >span:first-child {
                        color: #fff;
                        font-weight: bold;
                        font-size: 14px;
                    }

                    >span:not(:first-child) {
                        color: rgba(255, 255, 255, 0.8);
                        font-size: 13px;
                        cursor: pointer;
                        padding: 4px 12px;
                        border-radius: 4px;
                        transition: all 0.3s;

                        &:hover {
                            background: rgba(255, 255, 255, 0.2);
                        }

                        &.active {
                            background: #E92728;
                            color: #fff;
                            font-weight: bold;
                        }
                    }
                }

                >span {
                    font-size: 12px;
                    cursor: pointer;
                    color: rgba(255, 255, 255, 0.8);

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .grid {
                font-size: 13px;
                min-height: 200px;
                position: relative;

                >div {
                    display: grid;
                    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
                    text-align: center;
                    padding: 12px 0;

                    &:first-child {
                        background: #f5f7fa;
                        font-weight: bold;
                        color: #666;
                    }

                    &:not(:first-child):nth-child(odd) {
                        background-color: #fff;
                    }

                    &:not(:first-child):nth-child(even) {
                        background-color: #fafafa;
                    }

                    span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 0 8px;
                    }
                }
            }
        }

        .table2 {
            width: 100%;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            overflow: hidden;

            .tit {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: linear-gradient(135deg, #2899DF 0%, #1a7fc4 100%);
                padding: 12px 20px;

                >div {
                    display: flex;
                    align-items: center;
                    gap: 15px;

                    >span:first-child {
                        color: #fff;
                        font-weight: bold;
                        font-size: 14px;
                    }

                    >span:not(:first-child) {
                        color: rgba(255, 255, 255, 0.8);
                        font-size: 13px;
                        cursor: pointer;
                        padding: 4px 12px;
                        border-radius: 4px;
                        transition: all 0.3s;

                        &:hover {
                            background: rgba(255, 255, 255, 0.2);
                        }

                        &.active {
                            background: #E92728;
                            color: #fff;
                            font-weight: bold;
                        }
                    }
                }

                >span {
                    font-size: 12px;
                    cursor: pointer;
                    color: rgba(255, 255, 255, 0.8);

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .grid {
                font-size: 12px;
                min-height: 200px;

                >div {
                    display: grid;
                    grid-template-columns: 1fr 2fr repeat(8, 1fr);
                    text-align: center;

                    &:first-child {
                        background: #f5f7fa;
                        font-weight: bold;
                        color: #666;

                        span {
                            background: #f5f7fa;
                            border-color: #e8e8e8;
                        }
                    }

                    &:not(:first-child):nth-child(even) {
                        background-color: #fff;
                    }

                    &:not(:first-child):nth-child(odd) {
                        background-color: #fafafa;
                    }

                    span {
                        padding: 10px 5px;
                        border: 1px solid #e8e8e8;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &:first-child {
                            color: #2899DF;
                            font-weight: bold;
                        }
                    }

                    .sheetItem {
                        font-size: 16px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
}
</style>